import React, { Component, Fragment } from 'react'
import { Checkbox } from 'loyal-react'
import '@loyal_template/recharge.css'
import PeriodScheduleRecharge from './PeriodScheduleRecharge'
import PropTypes from 'prop-types'

class ScheduleRecharge extends Component {
  constructor (props) {
    super(props)

    this.onChangeScheduleOrder = this.onChangeScheduleOrder.bind(this)
  }

  onChangeScheduleOrder (e) {
    this.props.onChangeScheduleOrder(e)
  }

  render () {
    return (
      <Fragment>
        <div className='row'>
          <div className='col-12 color-ui-3 px-0'>
            <div className='row'>
              <Checkbox
                id='agendar_recarga'
                label='Agendar recarga para outro dia'
                className='d-none d-md-flex col-md-12 color-ui-3'
                onChange={this.onChangeScheduleOrder}
                defaultChecked={this.props.scheduleOrder}
              />
            </div>
          </div>
        </div>
        {this.props.scheduleOrder ? (
          <PeriodScheduleRecharge
            onChangeInnitialDate={this.props.onChangeInnitialDate}
            innitialDate={this.props.innitialDate}
            onChangeEndDate={this.props.onChangeEndDate}
            endDate={this.props.endDate}
            maxQuantityMonths={this.props.maxQuantityMonths}
          />
        ) : (
          ''
        )}
      </Fragment>
    )
  }
}

ScheduleRecharge.propTypes = {
  innitialDate: PropTypes.date,
  endDate: PropTypes.date,
  onChangeEndDate: PropTypes.func,
  onChangeInnitialDate: PropTypes.func,
  maxQuantityMonths: PropTypes.number.isRequired,
  onChangeScheduleOrder: PropTypes.func,
  scheduleOrder: PropTypes.bool
}

export default ScheduleRecharge



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ScheduleRecharge/ScheduleRecharge.js